/** Default number of rows shown per page across all list views. */
export const DEFAULT_PAGE_SIZE = 50;

/** Page size used by "load-all" store loops that fetch the full dataset. */
export const FETCH_ALL_PAGE_SIZE = 200;

/** Safety cap on the number of pages a "load-all" loop will request. */
export const FETCH_ALL_MAX_PAGES = 50;
